import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {ProductBrandService} from '../../../configuration/services/product-brand.service';
import {ProductCpuService} from '../../../configuration/services/product-cpu.service';
import {ProductModelService} from '../../../configuration/services/product-model.service';
import {ProductOperatingSystemService} from '../../../configuration/services/product-operating-system.service';
import {ProductStatusService} from '../../../configuration/services/product-status.service';
import {ProductRamService} from '../../../configuration/services/product-ram.service';
import {ProductStorageCapacityService} from '../../../configuration/services/product-storage-capacity.service';
import {ProductTelephoneCompanyService} from '../../../configuration/services/product-telephone-company.service';

import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
  providers: [ProductBrandService,ProductModelService,ProductOperatingSystemService,ProductStatusService,ProductStorageCapacityService,ProductTelephoneCompanyService,ProductRamService,ProductCpuService]
})
export class ProductComponent implements OnInit {

  @Input() transactionType: string;
  @Output() addProduct = new EventEmitter();
  id: number = undefined;
  name :string;
  private sub: any;
  productType: number = null;
  subTypes: any = [];
  brands: any = [];
  models: any = [];
  telephoneCompanies: any = [];
  operatingSystems: any = [];
  statuses: any = [];
  storageCapacities: any = [];
  product: any = {};
  rams: any = [];
  cpus: any =[];
  config: any = {'sourceField': ['name']};
  constructor(private productBrandService:ProductBrandService, private productModelService:ProductModelService, private productOperatingSystemService:ProductOperatingSystemService,
              private productRamService:ProductRamService,private productStatusService:ProductStatusService, private productStorageCapacityService:ProductStorageCapacityService, private productTelephoneCompanyService:ProductTelephoneCompanyService,private productCpuService:ProductCpuService,private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.getProductBrands();
    this.getProductModels();
    this.getProductOperatingSystems();
    this.getProductStatuses();
    this.getProductStorageCapacities();
    this.getProductTelephoneCompanies();
    this.getProductRams();
    this.getProductCpus();
 
  }


  commingback(){
    this.productType=null;
  }
 
  getProductCpus(){
    this.productCpuService.query({}).subscribe((productCpus) => {
      this.cpus = productCpus; 
    });
  }
  cpuSelected(e){
    this.product.cpu = e.name
  }

  getProductBrands(){
    this.productBrandService.query({}).subscribe((productBrands) => {
      this.brands = productBrands; 
    });
  }
  brandSelected(e){
    this.product.brand = e.name
  }

  getProductModels(){
    this.productModelService.query({}).subscribe((productModels) => {
      this.models = productModels; 
    });
  }
  modelSelected(e){
    this.product.model = e.name
  }

  getProductOperatingSystems(){
    this.productOperatingSystemService.query({}).subscribe((productOperatingSystems) => {
      this.operatingSystems = productOperatingSystems; 
    });
  }
  operatingSystemSelected(e){
    this.product.so = e.name
  }

  getProductStatuses(){
    this.productStatusService.query({}).subscribe((productStatuses) => {
      this.statuses = productStatuses; 
    });
  }
  productStatusesSelected(e){
    this.product.status = e.name
  }


  getProductStorageCapacities(){
    this.productStorageCapacityService.query({}).subscribe((productStorageCapacities) => {
      this.storageCapacities = productStorageCapacities; 
    });
  }
  storageCapacitiesSelected(e){
    this.product.storage_capacity = e.name
  }

  getProductTelephoneCompanies(){
    this.productTelephoneCompanyService.query({}).subscribe((productTelephoneCompanies) => {
      this.telephoneCompanies = productTelephoneCompanies; 
    });
  }
  telephoneCompanySelected(e){
    this.product.telephone_company = e.name
  }
  getProductRams(){
    this.productRamService.query({}).subscribe((productRams) => {
      this.rams = productRams; 
    });
  }
  ramSelected(e){
    this.product.ram = e.name
  }

  selectProductType(type){
    this.brands = this.brands.filter(function (brand){
      return brand.product_types.indexOf(type) !== -1;
    });
    this.models = this.models.filter(function (model){
      return model.product_types.indexOf(type) !== -1;
    });
    this.operatingSystems = this.operatingSystems.filter(function (operatingSystem){
      return operatingSystem.product_types.indexOf(type) !== -1;
    });
    this.statuses = this.statuses.filter(function (status){
      return status.product_types.indexOf(type) !== -1;
    });
    this.storageCapacities = this.storageCapacities.filter(function (storageCapacity){
      return storageCapacity.product_types.indexOf(type) !== -1;
    });
    this.telephoneCompanies = this.telephoneCompanies.filter(function (telephoneCompany){
      return telephoneCompany.product_types.indexOf(type) !== -1;
    });
    this.rams = this.rams.filter(function (ram){
      return ram.product_types.indexOf(type) !== -1;
    });
   this.cpus=this.cpus.filter(function(cpu){
      return cpu.product_types.indexOf(type) !==-1;
    });
    this.productType = type;
    if (type == 1){
      this.subTypes =[
        {id:1, name:"Móvil"},
        {id:2, name:"Tablet"}
      ]
    }else if (type == 4){
      this.subTypes =[
        {id:1, name:"PC"},
        {id:2, name:"Portatil"}
      ]
    }
  }

  addProducts(){
    if (   (this.productType === 1 && this.product.brand && this.product.model && this.product.storage_capacity && this.product.status && this.product.purchase_price && this.product.pin)
        || (this.productType === 2 && this.product.brand && this.product.model && this.product.storage_capacity && this.product.status && this.product.purchase_price)
        ||(this.productType === 4 && this.product.brand && this.product.model && this.product.so && this.product.status && this.product.serial_number  && this.product.cpu && this.product.ram && this.product.storage_capacity && this.product.purchase_price && this.product.pin)
        ||(this.productType === 3 && this.product.description )
        || (this.productType != 1 &&  this.productType != 2 && this.productType != 4 &&  this.productType != 3)){
      if (this.product.imei && this.product.imei.length === 15 && this.productType === 1 && this.product.sub_type === 1){
        this.product.type = this.productType;
        this.addProduct.emit(this.product);
      }else if (this.productType !== 1 || (this.productType === 1 && this.product.sub_type !== 1)){
        this.product.type = this.productType;
        this.addProduct.emit(this.product);
      }else{
        alert("El imei debe contener 15 dígitos");
      }
    }else{
      alert("Falta por rellenar datos obligatorios");
    }
  }

  calculatePurchasePrice(){
    if (this.transactionType === 'consignment'){
      if (this.product.sale_price <= 2){
        this.product.purchase_price = Math.round((this.product.sale_price*0.5)*100)/100;
      }else{
        this.product.purchase_price = Math.round((this.product.sale_price*0.6)*100)/100;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/products/components/product/product.component.ts